import PropTypes from 'prop-types';
import React from 'react';
// -*- mode: jsx;-*-
import { FundedProjectsYearFilter } from './FundedProjectsYearFilter.js';
import { FundedProjectList } from '../common/FundedProjectList.js';
import { ProjectList } from '../common/ProjectList.js';
import { Pagination } from '../common/pagination.js';

export let TeacherProfileProjectList = function ({ data, page, isMobile, showGiveWidget, fundedProjectsYear, onClickFundedProjectsYearFilter }) {
    const [givingPages, setGivingPages] = React.useState([]);

    const activeProjects = data.proposals.filter(p => p.fundingStatus === 'needs funding');
    const fundedProjects = data.proposals.filter(p => p.fundingStatus === 'funded');

    React.useEffect(() => {
        $.ajax({
            type: 'get',
            url: `${secureBaseURL}common/json-favorites.html`,
            cache: true,
            dataType: 'json',
            success: ({ data }) => {
                if (data.favIds) setGivingPages(data.favIds.myGPs);
            }
        });
    }, []);

    const renderActiveProjectsSection = function () {
        if (activeProjects.length > 0) {
            return (
                <div className="project-section-contents">
                    <h3>Current requests</h3>
                    <ProjectList
                        projects={activeProjects}
                        showGiveWidget={showGiveWidget}
                        donorGivingPages={givingPages}
                        hideClassroomPhoto={true} />
                </div>
            );
        }
    };

    const renderFundedProjectsSection = function () {
        if (fundedProjects.length > 0) {
            return (
                <div className="project-section-contents">
                    <FundedProjectsYearFilter selectedYear={fundedProjectsYear} onClickFundedProjectsYearFilter={onClickFundedProjectsYearFilter}/>
                    <h3>Past projects <span className="highlight-count">{data.totalFundedProposals}</span></h3>
                    <FundedProjectList projects={fundedProjects}/>
                </div>
            );
        }
    };

    const renderPagination = function () {
        if (activeProjects.length > 0 || fundedProjects.length > 0) {
            return <Pagination max={parseInt(data.totalProposals, 0)} page={page} simplePagination={isMobile} />;
        }
    };

    return (
        <div>
            {renderActiveProjectsSection()}
            {renderFundedProjectsSection()}
            {renderPagination()}
        </div>
    );
};

TeacherProfileProjectList.propTypes = {
    data: PropTypes.object.isRequired,
    page: PropTypes.number.isRequired,
    isMobile: PropTypes.bool,
    showGiveWidget: PropTypes.bool,
    fundedProjectsYear: PropTypes.number,
    onClickFundedProjectsYearFilter: PropTypes.func.isRequired,
};

TeacherProfileProjectList = React.memo(TeacherProfileProjectList);
